<template>
    <div class="main-cn">
        <div class="main-bd mg20">
            <el-tabs v-model="active_name" @tab-click="handleClick" v-loading="loading">
                <el-tab-pane v-for="(item, key) in active_list" :key="key" :label="item.label" :name="item.value"></el-tab-pane>
            </el-tabs>
            <el-row class="searchSection" >
                <SearchForm 
                :params="searcheModel" 
                :fields="fields" 
                :cache_field="'search_config_' + active_name + '_' + this.$route.path" 
                @search="submitSearch" 
                @reset="resetForm" 
                :key="search_form_key"> 
                </SearchForm>
            </el-row>
            <el-row class="addBtn">
                <el-button type="primary" size="small" v-if="active_name == 'index' && Acs('/customer-std/create')" @click="addCustomer()">新增客户</el-button>
                <el-button type="danger" size="small" v-if="active_name == 'index' && Acs('/customer-std/delete')" @click="showBatchDeleteDialog()" :disabled="multipleSelection.length == 0">批量删除</el-button>
            </el-row>
            <el-row :gutter="10" class="searchSection">
                <el-col :span="4">
                    <el-card>
                        <label class="item-title">所在地区</label>
                        <el-divider class="customr-divider"></el-divider>
                        <el-scrollbar style="height:750px;">
                            <el-tree 
                            :data="tree" 
                            node-key="id" 
                            @node-click="handleNodeClick" 
                            :default-expanded-keys="defaultExpandedKeys" 
                            :default-checked-keys="defaultExpandedKeys" 
                            check-on-click-node
                            :highlight-current="true" 
                            check-strictly 
                            v-loading="tree_loading">
                                <span class="custom-tree-node" slot-scope="{node, data}">
                                    <span>{{ node.label }}({{ data.value }})</span>
                                </span>
                            </el-tree>
                        </el-scrollbar>
                    </el-card>
                </el-col>
                <el-col :span="20">
                    <el-card>
                        <label class="item-title">客户列表</label>
                        <el-divider class="customr-divider"></el-divider>
                        <el-table
                        :data="list" 
                        border 
                        height="660"
                        @selection-change="handleSelectionChange"
                        v-loading="loading">
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column prop="id" label="客户ID"></el-table-column>
                            <el-table-column prop="name" label="客户名称"></el-table-column>
                            <el-table-column prop="short_name" label="客户简称"></el-table-column>
                            <el-table-column prop="corp_name" label="归属集团">
                                <template slot-scope="scope">
                                    <div v-for="(corp, index) in scope.row.corp" :key="index">
                                        {{corp.corp_name}}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="district_names" label="所在地区"></el-table-column>
                            <el-table-column prop="customer_trace_num" label="开通产品" width="250">
                                <template slot-scope="scope">
                                    <el-dropdown v-if="scope.row.products.length > 0">
                                        <div class="el-dropdown-link product-buyed" >
                                            <div v-for="(product, index) in _.orderBy(scope.row.products,['end_at','open_state'], ['desc', 'desc']).slice(0, 2)" :key="index">
                                                【{{product.state}}】{{product.product_name}}
                                                <span v-if="product.is_expire == '已到期'" style="color:red;">{{product.is_expire}}</span>
                                                <span v-else-if="product.is_expire != ''" style="color:green;">{{product.is_expire}}</span>
                                                <br>{{product.start_at_memo}}~{{product.end_at_memo}}
                                            </div>
                                        </div>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item v-for="(product, index) in _.orderBy(scope.row.products,['end_at','open_state'], ['desc', 'desc'])" :key="index" >
                                                <p>【{{product.state}}】{{product.product_name}}
                                                    <span style="color:red;" v-if="product.is_expire.indexOf('已到期')==0">{{product.is_expire}}</span>
                                                    <span style="color:green;" v-else>{{product.is_expire}}</span>
                                                </p>
                                                <p>{{product.start_at_memo}}~{{product.end_at_memo}}</p>
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                            <el-table-column prop="item_num" label="绑定资源数"></el-table-column>
                            <el-table-column prop="xueduan_str" label="开设学段"></el-table-column>
                            <el-table-column prop="type_name" label="客户类型">
                                <template slot-scope="scope">
                                    {{scope.row.type_name}}
                                    <span v-for="(tag, index) in scope.row.tag" :key="index">
                                        /{{tag.tag_name}}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="type_name" label="授权站点">
                                <template slot-scope="scope">
                                    <span v-for="(auth, index) in scope.row.auth_site" :key="index">
                                        &nbsp;{{auth.tag_name}}
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="username" label="业务员/协作人">
                                <template slot-scope="scope">
                                    {{scope.row.user ? scope.row.user.name : ''}}
                                    <div v-for="(cooperator, index) in scope.row.cooperator" :key="index">
                                        {{cooperator.user_name}}（协作）
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作">
                                <template slot-scope="scope">
                                    <el-button @click="handleView(scope.row)" type="text"  size="small">查看</el-button>
                                    <el-button type="text" size="small" @click="handleUpdate(scope.row)" v-if="active_name == 'index' && Acs('/customer-std/update')">编辑</el-button>
                                    <el-button type="text" size="small" @click="showDeleteDialog(scope.row)" v-if="active_name == 'index' && Acs('/customer-std/delete')" >删除</el-button>
                                    <el-button type="text" size="small" @click="showRevertDialog(scope.row)" v-if="active_name == 'recycle' && Acs('/customer-std/revert')">恢复</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <el-dialog title="删除客户" :visible.sync="dialogDelete" width="40%">
            <el-form ref="delete_form" :model="form" :rules="rules">
                <el-form-item label="删除原因：" prop="memo">
                    <el-input type="textarea" v-model="form.memo" placeholder="请输入删除原因"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogDelete = false">取 消</el-button>
                <el-button type="primary" @click="handleDelete()" :loading="form_loading">确 定</el-button>
            </div>
        </el-dialog>
    </div>
        
</template>
<style scoped>
.customr-divider {
    margin: 10px 0; /* 上边距10px，下边距10px */
}

</style>
<script>
import CustomerStdService from "~/services/CustomerStd";
import SearchForm from "~/widgets/SearchForm.vue";
import MyPagination from "~/widgets/MyPagination.vue";
export default {
    name: "std-list",

    components: {
        SearchForm,
        MyPagination
    },

    data() {
        return {
            tree: [],
            defaultExpandedKeys: [],
            list: [],
            tree_loading: false,
            loading: false,
            searcheModel: {},
            fields: [],
            search_form_key: 0,
            active_list: [
                {
                    label: '客户库管理',
                    value: 'index',
                },
                {
                    label: '回收站',
                    value: 'recycle',
                },
            ],
            dialogDelete: false,
            form_loading: false,
            multipleSelection: [],
            form: {
                customer_ids: [],
                memo: ''  
            },
            linkPage: null,
            rules: {
                memo: [{required: true, message: "请输入备注信息", trigger: "blur"}],
            },
            active_name: '',
            check_node: {},
        }
    },

    created: function () {
        this.initActive();
        this.resetForm();
    },
    
    methods: {
        initActive(){
            this.active_list = this.active_list.filter(item=>{
                if(!this.Acs('/customer-std/' + item.value)){
                    return false;
                }else if(!this.active_name){
                    this.active_name = item.value;
                }
                return true;
            });
        },

        //重置按钮
        resetForm() {
            this.fields = CustomerStdService.getFields(this.$route.path, this.active_name);
            this.searcheModel = {};
            this.list = [];
            this.search_form_key ++;
            
            this.submitSearch();
        },

        // 筛选查询
        submitSearch(params = null) {
            if(params){
                this.searcheModel = params;
            }
            params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            //请求侧边栏地区树
            this.getTree(params);
        },

        //获取列表
        getTree(params) {
            // loading 动画
            this.tree_loading = true;
            if(this.active_name == 'recycle'){
                params['is_deleted'] = 1;
            }
            CustomerStdService.getList(params, 'area-tree')
            .then((res) => {
                if (res.code == 0) {
                    this.tree = res.data;
                }
                this.tree_loading = false;
                this.handleNodeClick(this.check_node);
            })
            .catch((err) => {
                console.error(err);
                this.tree_loading = false;
            });
        },

        //获取列表
        getList(params) {
            if (!this.active_name || this.active_name < 1) {
                this.$message({
                    message: '无相关列表权限，请先授权！',
                    type: 'error'
                });
                return;
            }

            // loading 动画
            this.loading = true;
            CustomerStdService.getList(this.getAreaParams(params), this.active_name)
            .then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                if (res._meta) {
                    this.linkPage = res._meta;
                }
                this.loading = false;
            })
            .catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        handleClick() {
            this.submitSearch();
        },

        handleUpdate(customer) {
            this.$router.push({
                path: "/customer-std/update?id=" + customer.id,
            })
            // let routeData = this.$router.resolve({
            //     path: "/customer-std/update",
            //     query: { id: customer.id, from: 'index'},
            // });
            // window.open(routeData.href, '_blank');
        },

        //删除客户的提示和数据处理。
        showDeleteDialog(customer) {
            this.form.customer_ids = [customer.id];
            this.dialogDelete = true;
        },

        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        //展示批量删除客户对话框
        showBatchDeleteDialog() {
            this.form.customer_ids = this.multipleSelection.map(item => item.id);
            this.dialogDelete = true;
        },

        //删除客户
        handleDelete() {
            this.$refs["delete_form"].validate(valid => {
                this.form_loading = false;
                if (valid) {
                    CustomerStdService.delete(this.form).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                message:'删除成功',
                                type:'success'
                            });
                            this.submitSearch();
                        }
                        this.dialogDelete = false;
                    })
                } else {
                    this.form_loading = false;
                    return false;
                }
            });
        },

        //恢复客户的提示和数据处理。
        showRevertDialog(customer) {
            this.$confirm("确认将客户恢复到客户库？", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true
            }).then(() => {
                this.handleRevert([customer.id]);
            }).catch((err) => {
                console.error(err);
            });
        },

        //恢复客户
        handleRevert(ids) {
            CustomerStdService.revert({customer_ids: ids}).then(res => {
                if(res.code == 0){
                    this.$message({
                        message: '恢复成功',
                        type: 'success'
                    });
                    this.submitSearch();
                }else{
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    });
                }
            }).catch((err) => {
                console.error(err);
            });
        },

        handleSizeChange(newSize) {
            // 处理每页条目数变化事件
            this.searcheModel['perPage'] = newSize;
            this.getList(this.searcheModel);
        },

        handleCurrentChange(newPage) {
            // 处理当前页码变化事件
            this.searcheModel['page'] = newPage;
            this.getList(this.searcheModel);
        },

        handleNodeClick(data) {
            if(!data){
                return;
            }
            this.check_node = data;
            this.defaultExpandedKeys = [];
            if(this.check_node.level == 1){
                this.defaultExpandedKeys = [this.check_node.id];
            }else if(this.check_node.level == 2){
                this.defaultExpandedKeys = [this.check_node.pid, this.check_node.id];
            }else if(this.check_node.level == 3){
                this.defaultExpandedKeys = [this.check_node.province_id, this.check_node.pid, this.check_node.id];
            }
            this.getList(this.searcheModel);
        },

        getAreaParams(params = {}) {
            if(!this.check_node){
                return params;
            }
            if(this.check_node.level == 1){
                params['province_id'] = this.check_node.id;
                params['city_id'] = '';
                params['district_id'] = '';
            }else if(this.check_node.level == 2){
                params['province_id'] = this.check_node.pid;
                params['city_id'] = this.check_node.id;
                params['district_id'] = '';
            }else if(this.check_node.level == 3){
                params['province_id'] = this.check_node.province_id;
                params['city_id'] = this.check_node.pid;
                params['district_id'] = this.check_node.id;
            }
            return params;
        },

        addCustomer() {
            // let routeData = this.$router.resolve({
            //     path: "/customer-std/create",
            // });
            // window.open(routeData.href, '_blank');
            this.$router.push({
                path: "/customer-std/create",
            })
        },

        handleView(customer) {
            let routeData = this.$router.resolve({
                path: "/customers/view",
                query: { id: customer.id },
            });
            window.open(routeData.href, '_blank');
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/views/customer-std/index.vue